import groupBy from 'lodash/groupBy';

import type { WarrantyIDStatus } from '@/warranty/domain/entities/warranty-id-status';

import { getAverage } from '../utils/field-helpers';

import { getSuggestedAction } from './status';

export function aggregateWarrantyIdStatusToTopLevel(
  units: WarrantyIDStatus[],
): WarrantyIDStatus[] {
  const grouped = groupBy(units, (item) => item.topFullId);

  return Object.entries(grouped).map(([topFullId, items]) => {
    const { topFullId: id } = items[0];
    const { groupFullId } = items[0];
    const { topFullId: fullFrontendId } = items[0];
    // set unitFullId to null
    const unitFullId = undefined;

    // get highest status
    const warrantyCoverageStatus = items.reduce((highest, current) =>
      highest.warrantyCoverageStatus >= current.warrantyCoverageStatus
        ? highest
        : current,
    ).warrantyCoverageStatus;
    const complianceStatus = items.reduce((highest, current) =>
      highest.complianceStatus >= current.complianceStatus ? highest : current,
    ).complianceStatus;
    const dataStatus = items.reduce((highest, current) =>
      highest.dataStatus >= current.dataStatus ? highest : current,
    ).dataStatus;

    // get suggested action if
    const suggestedAction = getSuggestedAction(
      warrantyCoverageStatus,
      complianceStatus,
      dataStatus,
    );

    // calculate averages
    const ageInYears = Math.max(...items.map((i) => i.ageInYears));
    const throughputTotal = getAverage(
      items.map((i) => i.throughputTotal).filter((i) => i !== null),
    );
    const cyclesTotal = getAverage(items.map((i) => i.cyclesTotal));
    const sohPenaltyMax = Math.max(...items.map((i) => i.sohPenaltyMax));
    const sohAccure = Math.min(...items.map((i) => i.sohAccure));
    const sohGuaranteed = getAverage(items.map((i) => i.sohGuaranteed));

    // get sum unit counts
    const nUnitsPerformanceIssues = items.reduce(
      (sum, i) => sum + i.nUnitsPerformanceIssues,
      0,
    );
    const nUnitsOperationIssues = items.reduce(
      (sum, i) => sum + i.nUnitsOperationIssues,
      0,
    );

    return {
      id,
      groupFullId,
      topFullId,
      unitFullId,
      fullFrontendId,
      complianceStatus,
      dataStatus,
      warrantyCoverageStatus,
      suggestedAction,
      ageInYears,
      throughputTotal,
      cyclesTotal,
      sohPenaltyMax,
      sohGuaranteed,
      sohAccure,
      nUnitsPerformanceIssues,
      nUnitsOperationIssues,
    };
  });
}
